import React, { PropsWithChildren, useState } from 'react';
import { Theme, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { RootState } from 'store/rootReducer';
import AppBar from '../organisms/AppBar/AppBar';
import Sidebar, { drawerWidth } from '../organisms/Sidebar/Sidebar';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexWrap: 'nowrap',
        height: 'calc(100% - 60px)',
        width: '100%',
    },
    nav: {
        width: drawerWidth,
        height: '100%',
    },
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        height: '100%',
        width: '100%',
        overflowX: 'hidden',
    },
    wrapper: {
        flexGrow: 1,
        height: '100%',
        backgroundColor: theme.palette.background.default,
    },
}));

interface Props {
    location: string;
}

const MainTemplate = ({ location, children }: Props & PropsWithChildren<any>) => {
    const [isOpen, setIsOpen] = useState(false);
    const classes = useStyles();
    const { fullName } = useSelector((state: RootState) => state.userInfo);
    return (
        <>
            <div className={classes.root}>
                {/*<AppMenu />*/}
                <Hidden mdUp implementation="js">
                    <Sidebar variant="temporary" open={isOpen} onClose={() => setIsOpen(!isOpen)} />
                </Hidden>
                <Hidden smDown implementation="css">
                    <div className={classes.nav}>
                        <Sidebar />
                    </div>
                </Hidden>
                <div className={classes.wrapper}>
                    <AppBar onDrawerToggle={() => setIsOpen(!isOpen)} userName={fullName} />
                    <main className={classes.content} id="layout-container">
                        <TransitionGroup className="transition-group">
                            <CSSTransition key={location} classNames="route-animate" timeout={200}>
                                <section className="route-section">{children}</section>
                            </CSSTransition>
                        </TransitionGroup>
                    </main>
                </div>
            </div>
        </>
    );
};

export default MainTemplate;
